import { render, staticRenderFns } from "./SyncTiktok.vue?vue&type=template&id=71209b46&scoped=true"
import script from "./SyncTiktok.vue?vue&type=script&lang=js"
export * from "./SyncTiktok.vue?vue&type=script&lang=js"
import style0 from "./SyncTiktok.vue?vue&type=style&index=0&id=71209b46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71209b46",
  null
  
)

export default component.exports